import { useEffect } from 'react';
import { useNavigate } from 'react-router-dom';
import { useAuthStore } from '@/stores/authStore';

/**
 * AuthCallback — handles OAuth redirect.
 * Supabase automatically processes the URL hash (#access_token=...),
 * so we just need to wait for the auth state to update and redirect home.
 */
export function AuthCallback() {
  const session = useAuthStore((s) => s.session);
  const isHydrated = useAuthStore((s) => s.isHydrated);
  const navigate = useNavigate();

  useEffect(() => {
    if (isHydrated && session) {
      navigate('/', { replace: true });
    }
  }, [isHydrated, session, navigate]);

  return (
    <div className="flex h-screen w-screen items-center justify-center bg-[var(--bg-primary)]">
      <div className="flex flex-col items-center gap-4">
        <div className="h-10 w-10 animate-spin rounded-full border-4 border-[var(--xp-gold)] border-t-transparent" />
        <p className="text-sm text-[var(--text-secondary)]">Completing sign-in…</p>
      </div>
    </div>
  );
}
